module.exports = __webpack_public_path__ + "media/images/prev-8bd8823b026e69bab97eaf729fffd10a.svg";